<template>
  <div class="flex flex-col mt-8 justify-center mb-20">
    <div class="mb-8">
      <div class="flex bg-b2c-grey-600 justify-center text-b2c-grey-100 w-full h-auto py-6">
        <img v-if="productBrand" :src="productBrand.url_logo" :alt="productBrand.name.toUpperCase()" class="h-32">
      </div>
    </div>
    <carousel-fixed class="mb-10" />
    <section class="w-full flex flex-col" v-for="category in orderedProductsCategories" :key="category.id">
      <product-window :category="category" :brand="productBrand" />
    </section>
  </div>
</template>

<script>
import ProductService from '@/services/ProductService';
import { mapGetters } from 'vuex';
import CarouselFixed from '@/components/graphics/CarouselFixed.vue';
import ProductWindow from '../components/graphics/ProductWindow.vue';

export default {
  metaInfo() {
    const description = this.$t('metaDescriptions.brandCatalogs');
    return {
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  components: {
    CarouselFixed,
    ProductWindow,
  },

  data() {
    return {
      productBrand: null,
      productCategories: [],
    };
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),

    orderedProductsCategories() {
      const newArray = this.productCategories;
      return newArray.sort((categoryA, categoryB) => categoryB.id < categoryA.id);
    },
  },

  watch: {
    changedLocale() {
      this.getProductCategories();
    },
  },

  created() {
    this.getBrand();
  },

  methods: {
    getBrand() {
      ProductService.getProductBrand(this.$route.params.slug).then(({ data }) => {
        this.productBrand = data;
        this.getProductCategories();
      });
    },

    getProductCategories() {
      this.productCategories = [];
      ProductService.getAllProductCategories().then((response) => {
        this.productCategories = response.data;
      });
    },
  },
};
</script>
